import React from "react";

const vehicles = [
  {
    id: 1,
    name: "Honda Amaze",
    image: "images/fleet/Honda-Amaze.jpg",
    seater: "4+1",
    luggage: "2 Bags",
    fuel: "Petrol / Diesel",
    ac: "AC",
    desc: "Comfortable sedan ideal for airport transfers, local travel and outstation trips.",
  },
  {
    id: 2,
    name: "Hyundai Aura",
    image: "images/fleet/Hyundai-Aura.jpg",
    seater: "4+1",
    luggage: "2 Bags",
    fuel: "Petrol / Diesel",
    ac: "AC",
    desc: "Stylish sedan offering comfortable rides for city and outstation travel.",
  },
  {
    id: 3,
    name: "Hyundai Xcent",
    image: "images/fleet/Hyundai-Xcent.jpg",
    seater: "4+1",
    luggage: "2 Bags",
    fuel: "Petrol / Diesel",
    ac: "AC",
    desc: "Reliable sedan offering smooth rides for city and corporate travel.",
  },
  {
    id: 4,
    name: "Swift Dzire",
    image: "images/fleet/Swift-Dzire.jpg",
    seater: "4+1",
    luggage: "2 Bags",
    fuel: "Petrol / Diesel",
    ac: "AC",
    desc: "Popular sedan perfect for daily travel and airport transfers.",
  },
  {
    id: 5,
    name: "Toyota Etios",
    image: "images/fleet/Toyota-Etios.jpg",
    seater: "4+1",
    luggage: "3 Bags",
    fuel: "Diesel",
    ac: "AC",
    desc: "Comfortable and fuel-efficient sedan suitable for long-distance journeys.",
  },
  {
    id: 6,
    name: "Toyota Corolla Altis",
    image: "images/fleet/Toyota-Corolla-Altis.jpg",
    seater: "4+1",
    luggage: "3 Bags",
    fuel: "Petrol",
    ac: "AC",
    desc: "Premium luxury sedan with spacious interiors and superior comfort.",
  },
  {
    id: 7,
    name: "Maruti Ertiga",
    image: "images/fleet/Maruti-Ertiga.jpg",
    seater: "6+1",
    luggage: "4 Bags",
    fuel: "Petrol / CNG",
    ac: "AC",
    desc: "Spacious MPV ideal for family trips and small group travel.",
  },
  {
    id: 8,
    name: "Kia Carens",
    image: "images/fleet/Kia-Carens.jpg",
    seater: "6+1",
    luggage: "4 Bags",
    fuel: "Petrol / Diesel",
    ac: "AC",
    desc: "Premium MPV with modern features and comfortable seating.",
  },
  {
    id: 9,
    name: "Innova Crysta",
    image: "images/fleet/Innova-Crysta.jpg",
    seater: "6+1",
    luggage: "5 Bags",
    fuel: "Diesel",
    ac: "AC",
    desc: "Luxury MPV perfect for corporate travel and premium trips.",
  },
  {
    id: 10,
    name: "Tourist Special Innova",
    image: "images/fleet/Tourist-Special-Innova.jpg",
    seater: "7+1",
    luggage: "5 Bags",
    fuel: "Diesel",
    ac: "AC",
    desc: "Designed for sightseeing tours and pilgrimage journeys.",
  },
  {
    id: 11,
    name: "Scorpio",
    image: "images/fleet/Scorpio.jpg",
    seater: "7+1",
    luggage: "4 Bags",
    fuel: "Diesel",
    ac: "AC",
    desc: "Powerful SUV suitable for family vacations and outstation travel.",
  },
  {
    id: 12,
    name: "Tempo Traveller",
    image: "images/fleet/Tempo-Traveller.jpg",
    seater: "13 / 17",
    luggage: "10 Bags",
    fuel: "Diesel",
    ac: "AC / Non AC",
    desc: "Best vehicle for group tours, weddings and family trips.",
  },
  {
    id: 13,
    name: "Urbania",
    image: "images/fleet/Urbania.jpg",
    seater: "17",
    luggage: "12 Bags",
    fuel: "Diesel",
    ac: "AC",
    desc: "Luxury traveller with premium interiors and spacious seating.",
  },
  {
    id: 14,
    name: "Mini Bus",
    image: "images/fleet/Mini-Bus.jpg",
    seater: "20-32",
    luggage: "20 Bags",
    fuel: "Diesel",
    ac: "AC / Non AC",
    desc: "Ideal for corporate transport, weddings and group tours.",
  },
];

const OurFleets = () => {
  return (
    <>
    
  <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.3)",
            zIndex: 1, }}></div>

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Our Fleets</h1>
          </div>
        </div>
      </div>



    
    <div className="section-full py-3 fleet-wrap">
      <div className="container">

        {/* Title */}
      

        {/* Grid */}
        <div className="row">

          {vehicles.map((item) => (
            <div key={item.id} className="col-lg-4 col-md-4 col-sm-6 mb-4">

              <div className="fleet-card">

                <div className="fleet-img">
                  <img src={item.image} alt={item.name} />
                </div>

           
<div className="fleet-content">
  <h4>{item.name}</h4>

  <div className="fleet-specs">
    <span>👥 {item.seater}</span>
    <span>🧳 {item.luggage}</span>
  </div>

  <div className="fleet-specs">
    <span>❄️ {item.ac}</span>
    <span>⛽ {item.fuel}</span>
  </div>

  <p>{item.desc}</p>

</div>



              </div>

            </div>
          ))}

        </div>

      </div>

      {/* Styling */}
      <style jsx>{`
        .fleet-wrap {
          background: linear-gradient(135deg, #fff7ed, #fef3e2);
        }

        .fleet-card {
          background: #fff;
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid #f3d6b3;
          box-shadow: 0 6px 18px rgba(90, 45, 12, 0.12);
          transition: 0.3s;
          height: 100%;
        }

        .fleet-card:hover {
          transform: translateY(-6px);
        }

        .fleet-img img {
          width: 100%;
        //   height: 200px;
          object-fit: cover;
        }

        .fleet-content {
          padding: 15px;
          text-align: center;
        }

        .fleet-content h4 {
          color: #FF681A;
          margin-bottom: 8px;
        }

        .fleet-content p {
          color: #192555;
          font-size: 14px;
          margin: 0;
        }
      `}</style>
    </div>
    </>
  );
};

export default OurFleets;